import React from "react";
import { Space, Tag, Tooltip, Typography, message } from "antd";
import { SERVICE_VARIABLES, variableToken } from "./constant";

const { Text } = Typography;

// Clickable variable chips for service pages. Without `onPick` a click copies
// the variable (to paste into any section field); with it, the variable is
// handed to `onPick` (e.g. appended to an SEO field).
const DynamicVariables = ({ onPick, label = "Dynamic variables:", compact = false }) => {
  const pick = async (token) => {
    if (onPick) {
      onPick(token);
      return;
    }
    try {
      await navigator.clipboard.writeText(token);
      message.success(`Copied ${token}. Paste it into any text field.`);
    } catch {
      message.info(`Use ${token} in any text field.`);
    }
  };

  return (
    <Space size={[4, 6]} wrap style={{ marginTop: compact ? 4 : 0 }}>
      {label && (
        <Text type="secondary" style={{ fontSize: 12 }}>
          {label}
        </Text>
      )}
      {SERVICE_VARIABLES.map(({ key, label: hint }) => {
        const token = variableToken(key);
        return (
          <Tooltip key={key} title={hint}>
            <Tag
              color="blue"
              style={{ cursor: "pointer", fontFamily: "monospace", marginInlineEnd: 0 }}
              onClick={() => pick(token)}
            >
              {token}
            </Tag>
          </Tooltip>
        );
      })}
    </Space>
  );
};

export default DynamicVariables;
